import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=c823632e&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=c823632e&prod&scoped=true&lang=css"
import style1 from "./Course.vue?vue&type=style&index=1&id=c823632e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c823632e",
  null
  
)

export default component.exports